import React from "react";
import styled from "@emotion/styled";
import { fadeIn, growFromLeftRounded } from "styles/animations";

import { currencyFormat, numberFormatLong } from "components/app_layout/Typography";

type Props = {
  value: number;
  maxValue?: number;
  type: "currency" | "count";
  onClick: () => void;
};

function ValueBar({ value, maxValue, type = "count", onClick }: Props) {
  return (
    <ChartContainer onClick={onClick}>
      <Chart
        value={value}
        maxValue={
          maxValue ?? 0 // if no max value, then bar chart is not shown
        }
      />
      <ChartLabel>
        {type === "currency" ? currencyFormat(value, "GBP") : numberFormatLong(value)}
      </ChartLabel>
    </ChartContainer>
  );
}

const ChartContainer = styled.button(({ theme }) => ({
  background: "unset",
  border: "none",
  height: "50px",
  width: "100%",
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  cursor: "pointer",
  WebkitPrintColorAdjust: "exact",
  printColorAdjust: "exact",
  "&:focus-visible": {
    outline: `2px solid ${theme.colors.sysPrimarySubtleAlt}`,
  },
}));

const ChartLabel = styled.div({
  paddingLeft: 5,
  fontSize: "12px",
  animation: `${fadeIn} 1s forwards`,
});

const Chart = styled.div<{ value: number; maxValue: number; color?: string }>(
  ({ value, maxValue, color, theme }) => ({
    width: `${(Math.min(value, maxValue) / (maxValue || 1)) * 100}%`, // Prevent division by 0 & numbers greater than 100%
    height: "16px",
    backgroundColor: color ?? theme.colors.sysPrimaryDefault,
    borderRadius: "4px",
    animation: `${growFromLeftRounded} 1s ease-in-out`,
  }),
);

export default ValueBar;
